"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PDFEmbed_1 = __importDefault(require("../utils/PDFEmbed"));
var styled_components_1 = require("styled-components");
function PDFEmbedFunction(props) {
    var theme = (0, styled_components_1.useTheme)();
    var filePath = props.filePath, fileName = props.fileName, fileID = props.fileID;
    (0, react_1.useEffect)(function () {
        var pdfEmbed = new PDFEmbed_1.default(theme);
        pdfEmbed.ready().then(function () {
            /* Invoke file preview */
            pdfEmbed.previewFile(fileID, {
                /* Pass the embed mode option here */
                embedMode: "SIZED_CONTAINER",
                // showDownloadPDF : false,
                // wZoomControl : false,
                // showFullScreen: false,  
                // showPrintPDF: false,
                enableLinearization: true,
                enableSearchAPIs: false,
            }, 
            // pass pdf meta deta here
            {
                name: fileName,
                path: filePath,
                // "http://www.pdf995.com/samples/pdf.pdf",
            });
        });
    }, []);
    return react_1.default.createElement("div", { id: "".concat(fileID), style: { height: "450px" } });
}
exports.default = PDFEmbedFunction;
